import {
  deleteDataTraining,
  fetchDataTraining,
  patchDataTraining,
  postDataTraining,
} from "../services/training";

const handleFetchUsers = async () => {
  const uri = `api/users`;
  const response = fetchDataTraining({ uri });
  return response;
};

const handleFetchUser = async ({ _id }: any) => {
  const uri = `api/users/${_id}`;
  const response = fetchDataTraining({ uri });
  return response;
};

const handleFetchCompanyUser = async ({ _id }: any) => {
  const uri = `api/users/company/${_id}`;
  const response = fetchDataTraining({ uri });
  return response;
};

const handleCreateUser = async (data: any) => {
  const uri = `api/users`;
  const response = postDataTraining({ data, uri });
  return response;
};

const handleUpdateUser = async ({ data, _id }: any) => {
  const uri = `api/users/${_id}`;
  const response = patchDataTraining({ data, uri });
  return response;
};

const handleMigrateUser = async ({ data, _id }: any) => {
  const uri = `api/users/${_id}/migrate`;
  const response = patchDataTraining({ data, uri });
  return response;
};

const handleDeleteUser = async ({ _id }: any) => {
  const uri = `api/users/${_id}`;
  const response = deleteDataTraining({ uri });
  return response;
};

export {
  handleFetchUsers,
  handleFetchUser,
  handleCreateUser,
  handleUpdateUser,
  handleDeleteUser,
  handleMigrateUser,
  handleFetchCompanyUser,
};
